import React from "react";
import Chart from "react-google-charts";

const WeeklyChart = ({ weeklyData }) => (
    <Chart
        width="100%"
        height="350px"
        chartType="ColumnChart"
        loader={<div>Loading Chart</div>}
        data={weeklyData}
        options={{
            title: "Weekly",
            colors: ["#ff3541", "#737f8c"],
            chartArea: { width: "80%" },
            hAxis: {
                title: "Days",
                minValue: 0,
            },
            vAxis: {
                title: "Money",
                format: "currency",
            },
            tooltip: { isHtml: true, trigger: "visible" },
        }}
    />
);

export default WeeklyChart;
